import { render, staticRenderFns } from "./SortingOptions.vue?vue&type=template&id=4fe5e766&scoped=true&"
import script from "./SortingOptions.vue?vue&type=script&lang=js&"
export * from "./SortingOptions.vue?vue&type=script&lang=js&"
import style0 from "./SortingOptions.vue?vue&type=style&index=0&id=4fe5e766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5e766",
  null
  
)

export default component.exports